// @flow
import type { SimpleOffer } from "types/offer";

export const FETCH_OFFERS_BEGIN = "FETCH_OFFERS_BEGIN";
export const FETCH_OFFERS_SUCCESS = "FETCH_OFFERS_SUCCESS";
export const FETCH_OFFERS_FAILURE = "FETCH_OFFERS_FAILURE";

type FetchOffersBegin = {
  type: typeof FETCH_OFFERS_BEGIN,
};

type FetchOffersSuccess = {
  type: typeof FETCH_OFFERS_SUCCESS,
  payload: { offers: SimpleOffer[] },
};

type FetchOffersFailure = {
  type: typeof FETCH_OFFERS_FAILURE,
  payload: { error: Object },
};

export type Action = FetchOffersBegin | FetchOffersSuccess | FetchOffersFailure;

export function fetchOffersBegin() {
  return {
    type: FETCH_OFFERS_BEGIN,
  };
}

export function fetchOffersSuccess(offers: SimpleOffer[]) {
  return {
    type: FETCH_OFFERS_SUCCESS,
    payload: { offers },
  };
}

export function fetchOffersFailure(error: Object) {
  return {
    type: FETCH_OFFERS_FAILURE,
    payload: { error },
  };
}

export function fetchManagerOffers() {
  return async (dispatch: (Action) => void) => {
    const ORGANIZER_API = (await import("services/organizer-api")).default;
    const SMARTLINK_API = (await import("services/smartlink-api")).default;

    dispatch(fetchOffersBegin());

    Promise.all([ORGANIZER_API.get("/offers/simple"), SMARTLINK_API.get("/offers/simple")])
      .then(([{ data: data1 }, { data: data2 }]) => dispatch(fetchOffersSuccess([...data1, ...data2])))
      .catch((err) => dispatch(fetchOffersFailure(err)));
  };
}

export function fetchAffiliateOffers() {
  return async (dispatch: (Action) => void) => {
    const API = (await import("services/organizer-api")).default;

    dispatch(fetchOffersBegin());

    API.get("/offers/simple")
      .then(({ data }) => dispatch(fetchOffersSuccess(data)))
      .catch((err) => dispatch(fetchOffersFailure(err)));
  };
}
